import React,{useEffect, useLayoutEffect, useState, useCallback} from 'react'
import './style.css'
import {Handle,Position,useReactFlow,useStoreApi,useHandleConnections,useStore} from '@xyflow/react'


export const SinglVectorTraitNodes = ({id,data}:any) => {
    const [nodeData,setNodeData] = useState(data)
  return (
    <>
    <div className="box">
        <div className="box-header">
            <span>{data.title}</span>
            <span className="label">{nodeData.type}</span>
            <button className="settings-btn">⚙</button>
        </div>
        <div className="box-content">
            <div className="input-group">
                <label htmlFor="x">x</label>
                <input type="text" id="x" value={nodeData.x} onChange={(e) => setNodeData({...nodeData,x:e.target.value})}/>
            </div>
            <div className="input-group">
                <label htmlFor="y">y</label>
                <input type="text" id="y" value={nodeData.y} onChange={(e) => setNodeData({...nodeData,y:e.target.value})}/>
            </div>
            <div className="input-group">
                <label htmlFor="z">z</label>
                <input type="text" id="z" value={nodeData.z} onChange={(e) => setNodeData({...nodeData,z:e.target.value})}/>
            </div>
        </div>
        
    </div>
    <Handle 
    type='source' 
    position={Position.Right} 
    style={{ 
      background: 'lightgrey',
      width: '6px',
      height: '6px', 
      borderRadius: '50%',
      bottom: '-5px',
      border: '1px solid #fff',
    position:'absolute'
    }}
  />
  </>
  )
}

export const MultiTraitNodes = ({id,data}:any) => {
    const store = useStoreApi();
    const { getNode } = useReactFlow();
    
    const childNodes = store.getState().nodes
        .filter((n:any) => n.parentId === id)
        .map((n:any) => getNode(n.id));

    const addChild = (e:any) => {
        e.preventDefault()
        data.onAddNode(id)
    }
    return (
        <>
        <Handle 
                        type='target' 
                        position={Position.Right} 
                        style={{ 
                            background: 'lightgrey',
                            width: '6px',
                            height: '6px', 
                            borderRadius: '50%',
                            top: '60px',
                            border: '1px solid #fff',
                          position:'absolute'
                          }}
                    />
        <div className="custom-box" style={{ minHeight: '500px' }}>
        <div className="custom-box-header">
            <span className="custom-title">Hell</span>
            <span className="custom-label">FRAG</span>
            <button className="custom-settings-btn" onClick={addChild}>+</button>
        </div>
        <div className="custom-box-content">
            <div className="custom-section-title">Uniforms</div>
            <ul className="custom-item-list">
                {/* {childNodes.map((n:any,index:any) => {
                    return (
                    <SingleTraitNode key={n.id} id={n.id} data={n.data} index={index} parentId={id}/>
                )

                } )} */}
                {/* <li className="custom-item"><input type="checkbox" className="custom-checkbox" /> modelMatrix <span className="custom-type">mat4</span></li>
                <li className="custom-item"><input type="checkbox" className="custom-checkbox" /> color <span className="custom-type">vector3</span></li>
                <li className="custom-item"><input type="checkbox" className="custom-checkbox"/> time <span className="custom-type">number</span></li>
                <li className="custom-item"><input type="checkbox" className="custom-checkbox" /> modelViewMatrix <span className="custom-type">mat4</span></li>
                <li className="custom-item"><input type="checkbox" className="custom-checkbox" /> projectionMatrix <span className="custom-type">mat4</span></li>
                <li className="custom-item"><input type="checkbox" className="custom-checkbox" /> viewMatrix <span className="custom-type">mat4</span></li>
                <li className="custom-item"><input type="checkbox" className="custom-checkbox" /> normalMatrix <span className="custom-type">mat3</span></li> */}
            </ul>
        </div>
    </div>
    </>
    )
}

export const SingleTraitNode = ({id,data,parentId}:any) => {
    const [isConnected,setIsConnected] = useState(false)
    const {getEdges,getNodes} = useReactFlow()
    const connections = useHandleConnections({type: 'target'});
    const isHandleConnected = (nodeId:any, handleId:any, handleType:any) => {
        
        const node = getNodes().find((n:any) => n.id === nodeId);
        if (!node) return false;
      
        const edges = getEdges();
        const connectionType = handleType === 'source' ? 'source' : 'target';
        
        return edges.some(
          (edge:any) =>
            edge[connectionType] === nodeId &&
            edge[`${connectionType}Handle`] === handleId
        );
    
        
      }

    

    const handleChanged = () => {
        let ishandleConnected = isHandleConnected(id, `${parentId}-target-${id}`, 'target')
        setIsConnected(ishandleConnected)
    }

    useLayoutEffect(() => {

    },[isConnected,setIsConnected])

      
    return (
        <>
        <Handle 
                        id={`${parentId}-target-${id}`}
                        type='target' 
                        position={Position.Left} 
                        style={{ 
                            background: 'lightgrey',
                            width: '6px',
                            height: '6px', 
                            borderRadius: '50%',
                            bottom: '-5px',
                            border: '1px solid #fff',
                          position:'absolute'
                          }}
                          onConnect={(connections:any) => setIsConnected(true)}
                    />
                    <li className="custom-item"> {data.name} <span>{data.type}</span></li>
        </>
        
    )
}




export const SimpleTraitNodes = ({id,data}:any) => {
    const [nodeData,setNodeData] = useState(data)
    return (
        <>
        <div className="metalness-box">
        <div className="metalness-header">
            <span className="metalness-title">{nodeData.title}</span>
            <span className="metalness-label">{nodeData.label}</span>
            <button className="metalness-settings-btn">⚙</button>
        </div>
        <div className="metalness-content">
            <input type="text" className="metalness-input" value={nodeData.value} onChange={(e) => setNodeData({...nodeData,value:e.target.value})} />
            <span className="metalness-type">{nodeData.type}</span>
        </div>
        
    </div>
    <Handle 
    type='source' 
    position={Position.Right} 
    style={{ 
      background: 'lightgrey',
      width: '6px',
      height: '6px', 
      borderRadius: '50%',
      bottom: '-5px',
      border: '1px solid #fff',
    position:'absolute'
    }}
  />
  </>
    )
}